import request from "@/utils/request";

let baseApi = '/cotti-capi'

export function getAnnualReport2025(data) {
  return request({
    url: `${baseApi}/userReport/user2025Report`,
    method: "POST",
  });
}

export function getAnnualReportConfig2025(data) {
  return request({
    url: `${baseApi}/userReport/reportConfig`,
    method: "POST",
  });
}